class BESSAppViewUpdatedEvent extends BESSAppEvent {
    static name = 'BESSAppViewUpdatedEvent';


    constructor(target) {
        super(BESSAppViewUpdatedEvent.name);
        this.target = target;
    }
}